import { useState } from 'react';

const useCustomHook = () => {
  const [redirect, setRedirect] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingOTP, setLoadingOTP] = useState(false);

  return {
    redirect, setRedirect,
    loading, setLoading,
    loadingOTP, setLoadingOTP,
  };
};

export default useCustomHook;
